/*   */
import React, { useState, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import {
  RemoteVideos,
  useRosterState,
  ContentShare,
  FeaturedRemoteVideos,
  useContentShareControls,
  useMeetingManager,
  useLocalAudioOutput,
  useLocalVideo,
  useAttendeeStatus,
} from "amazon-chime-sdk-component-library-react";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CallEndIcon from "@mui/icons-material/CallEnd";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import Button from "@mui/material/Button";
import ScreenShareIcon from "@mui/icons-material/ScreenShare";
import Fab from "@mui/material/Fab";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import StopScreenShareIcon from "@mui/icons-material/StopScreenShare";
import { updateChimeFunc } from "../../store/ducks/auth.duck";
import { connect } from "react-redux";
import { useSnackbar } from "notistack";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import { Rnd } from "react-rnd";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const useStyles = makeStyles()((theme) => ({
  videoCompChime: {
    width: "100% !important",
    height: "100% !important",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  controls: {
    position: "absolute",
    bottom: 20,
    width: "70%",
    zIndex: 3000,
    margin: "auto",
    display: "flex",
    justifyContent: "space-around",
  },
  controls2: {
    position: "absolute",
    top: 10,
    // width: "40%",
    zIndex: 3000,
    display: "flex",
    right: 0,
    justifyContent: "space-around",
  },
}));

let ucount = 0;
let joinMeetingID = "";
function MeetingPage(props) {
  const { classes } = useStyles();
  const routeLocation = useLocation();
  const { isVideoEnabled, toggleVideo } = useLocalVideo();
  const { isAudioOn, toggleAudio } = useLocalAudioOutput();

  const meetingManager = useMeetingManager();
  const [open, setOpen] = useState(false);
  const [userID, setuserID] = useState("");
  const [tutorid, settutorid] = useState(props.chimeMeeting.tutorID);

  //drag positions
  const [posX, setposX] = useState(0);
  const [posY, setposY] = useState(0);
  const [dragWidth, setdragWidth] = useState("25%");
  const [dragHeight, setdragHeight] = useState(300);
  const [mainHeight, setmainHeight] = useState(50);

  const [isFullScreen, setisFullScreen] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const tutorDetails = useAttendeeStatus(tutorid);
  const { roster } = useRosterState();
  const rosterArray = Object.keys(roster);
  const { isLocalUserSharing, toggleContentShare } = useContentShareControls();

  const meetingEnded = () => {
    meetingManager.leave();
    props.updateChimeFunc({
      status: "null",
      studentID: "",
      tutorID: "",
    });
    let updates = {};
    updates[
      "/meetings/" + props.chimeMeeting.meetingInfo.MeetingId + "/status"
    ] = "endedByStudent";
    firebase
      .database()
      .ref()
      .update(updates);
    enqueueSnackbar("You ended the meeting", { variant: "info" });
  };

  useEffect(() => {
    if (
      !isVideoEnabled &&
      props.chimeMeeting.status === "meetingStartedStudent"
    ) {
      toggleVideo();
    }
    if (props.chimeMeeting.status === "rejected") {
      meetingManager.leave();
    }
  }, [props.chimeMeeting.status]);

  useEffect(() => {
    settutorid(props.chimeMeeting.tutorID);
  }, [props.chimeMeeting]);

  useEffect(() => {
    if (props.isUserLogin) {
      tutorMeetingArrangement();
    }
  }, [props.isUserLogin]);

  const tutorMeetingArrangement = async () => {
    let user = await firebase.auth().currentUser;

    if (user) {
      setuserID(user.uid);
      let isUseTutor = await firebase
        .database()
        .ref("/KeyStore/" + user.uid + "/isTutor")
        .once("value")
        .then((snapshot) => (snapshot.val() ? snapshot.val() : false));
      if (isUseTutor) {
        //adding meeting listner
        firebase
          .database()
          .ref("/KeyStore/" + user.uid)
          .on("value", (snap) => {
            let val = snap.val().activeMeetingNotify;
            if (val && val === true) {
              firebase
                .database()
                .ref("/KeyStore/" + user.uid + "/activeMeetingID")
                .once("value", (meetingId) => {
                  if (meetingId.val()) {
                    //checking meeting status
                    firebase
                      .database()
                      .ref("/meetings/" + meetingId.val())
                      .once("value", (snap) => {
                        joinMeetingID = meetingId.val();
                        setOpen(true);
                        checkForMeetingStatus();
                      });
                  }
                });
            }
          });
      }
    }
  };

  const checkForMeetingStatus = () => {
    if (joinMeetingID) {
      //checking for meeting status
      firebase
        .database()
        .ref("/meetings/" + joinMeetingID)
        .on("value", (snap) => {
          if (
            snap.val() &&
            snap.val().status &&
            snap.val().status === "endedByStudent"
          ) {
            setOpen(false);
            let updates = {};
            updates["/KeyStore/" + userID + "/activeMeetingNotify"] = false;
            firebase
              .database()
              .ref()
              .update(updates);
          }
        });
    }
  };

  const Join = () => {
    let updates = {};
    updates["/KeyStore/" + userID + "/activeMeetingNotify"] = false;
    firebase
      .database()
      .ref()
      .update(updates);
    setOpen(false);
    props.history.push("/meeting/" + joinMeetingID);
  };

  const Dismiss = () => {
    let updates = {};
    updates["/KeyStore/" + userID + "/activeMeetingNotify"] = false;
    updates["/meetings/" + joinMeetingID + "/status"] = "rejectedByTutor";

    firebase
      .database()
      .ref()
      .update(updates);
    setOpen(false);
  };

  const fullScreenHandler = () => {
    let val = !isFullScreen;
    setisFullScreen(!isFullScreen);

    if (val) {
      setposX(0);
      setposY(0);
      setmainHeight(null);
      setdragWidth("100%");
      setdragHeight("100vh");
    } else {
      setposX(0);
      setposY(0);
      setmainHeight(50);
      setdragWidth("25%");
      setdragHeight(300);
    }
  };

  return (
    <>
      {(() => {
        if (
          //routeLocation.pathname.includes("lesson") &&
          props.chimeMeeting.status === "meetingStartedStudent"
        ) {
          return (
            <div
              style={{
                zIndex: 2000,
                height: 300,
                width: "100%",
                position: "fixed",
                left: 0,
                bottom: mainHeight,
              }}
            >
              <Rnd
                size={{ width: dragWidth, height: dragHeight }}
                position={{ x: posX, y: posY }}
                onDragStop={(e, d) => {
                  setposX(d.x);
                  setposY(d.y);
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  setdragWidth(ref.style.width);
                  setdragHeight(ref.style.height);
                  setposX(position.x);
                  setposY(position.y);
                }}
                disableDragging={isFullScreen}
              >
                <div
                  id="meetingCon"
                  style={{
                    border: "0.5px solid #585858",
                    width: "100%",
                    height: "100%",

                    zIndex: 2000,
                  }}
                >
                  <div
                    id="meetingControls"
                    style={{
                      width: "100%",
                      // display:"flex",
                      justifyContent: "center",
                      display: rosterArray.length === 1 ? "flex" : "",
                    }}
                  >
                    <div className={classes.controls}>
                      <Fab
                        onClick={() => meetingEnded()}
                        style={{ backgroundColor: "red" }}
                        size="small"
                        aria-label="callEnd"
                      >
                        <CallEndIcon style={{ color: "#ffffff" }} />
                      </Fab>

                      <Fab
                        onClick={toggleVideo}
                        color="primary"
                        size="small"
                        aria-label="videoCall"
                      >
                        {isVideoEnabled ? (
                          <VideoCallIcon style={{ color: "#ffffff" }} />
                        ) : (
                          <VideocamOffIcon style={{ color: "#ffffff" }} />
                        )}
                      </Fab>

                      <Fab
                        onClick={toggleAudio}
                        color="primary"
                        size="small"
                        aria-label="mute"
                      >
                        {isAudioOn ? (
                          <VolumeUpIcon style={{ color: "#ffffff" }} />
                        ) : (
                          <VolumeOffIcon style={{ color: "#ffffff" }} />
                        )}
                      </Fab>

                      <Fab
                        color="primary"
                        onClick={toggleContentShare}
                        size="small"
                        aria-label="ScreenShare"
                      >
                        {isLocalUserSharing ? (
                          <ScreenShareIcon style={{ color: "#ffffff" }} />
                        ) : (
                          <StopScreenShareIcon style={{ color: "#ffffff" }} />
                        )}
                      </Fab>
                    </div>
                    <div className={classes.controls2}>
                      <IconButton
                        style={{ marginRight: "20px" }}
                        onClick={fullScreenHandler}
                        color="default"
                        aria-label="fillscreen"
                      >
                        {!isFullScreen ? (
                          <FullscreenIcon style={{ color: "#ffffff" }} />
                        ) : (
                          <FullscreenExitIcon style={{ color: "#ffffff" }} />
                        )}
                      </IconButton>
                    </div>
                  </div>
                  {rosterArray.length > 1 ? (
                    <>
                      {tutorDetails.videoEnabled ||
                      tutorDetails.sharingContent ? (
                        <div className={classes.videoCompChime}>
                          <RemoteVideos className={classes.videoCompChime} />
                          {tutorDetails.sharingContent && (
                            <ContentShare className={classes.videoCompChime} />
                          )}
                        </div>
                      ) : (
                        <div
                          className={classes.videoCompChime}
                          style={{
                            backgroundColor: "#1b1616",
                            color: "#ffffff",
                          }}
                        >
                          Video Disabled
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className={classes.videoCompChime}
                      style={{ backgroundColor: "#1b1616" }}
                    >
                      <CircularProgress
                        color="primary"
                        style={{ marginBottom: 25 }}
                        size={35}
                      />
                    </div>
                  )}
                </div>{" "}
              </Rnd>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={open}
        message="Join the Meeting"
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={Join}>
              Join
            </Button>
            <Button color="secondary" size="small" onClick={Dismiss}>
              Dismiss
            </Button>
          </React.Fragment>
        }
      />
    </>
  );
}

const mapStateToProps = ({ auth: { chimeMeeting, isUserLogin } }) => ({
  chimeMeeting,
  isUserLogin,
});

export default connect(mapStateToProps, { updateChimeFunc })(MeetingPage);
